
import './styles.css';
import InsaneTable from '../../component/insane-table'

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function ProductionChecksheetSheet() {
    let plantList = [];

    HttpRequest("/admin/pd/plant/get", {}).then(data => {
        // console.log("_plant" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.plants.length; i++) {
                const _plant = data.plants[i];
                plantList.push({
                    displayName: _plant.plantid + " (" +_plant.plantname + ")",
                    value: _plant.plantid
                })
            }
        }
    });

    const tableOption = {
        tableName: "Sheet",
        className: "",
        search: [
            {
                reqName: "search_checksheetname",
                displayName: "Check Sheet Name",
                element: "input",
                placeholder: "Enter Check Sheet Name."
            }
        ],
        mapTable: [
            {
                displayName: "ID",
                attName: "checksheetid",
                type: "text",
                form: {
                    validate: true,
                    enable: false,
                    element: "input"
                }
            },
            {
                displayName: "Name",
                attName: "checksheetname",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Plant",
                attName: "plantid",
                type: "id",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: plantList
                }
            },
            {
                displayName: "Report",
                attName: "reportemail",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/pd/checksheet/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "plantid": "",
                    "search_checksheetname":""
                }
            },
            insert: {
                enable: true,
                url: "/admin/pd/checksheet/update",
                dataReq: {
                    "plantid": "",
                    "reportemail": "",
                    "checksheetname": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/pd/checksheet/update",
                dataReq: {
                    "checksheetid": "",
                    "plantid": "",
                    "reportemail": "",
                    "checksheetname": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/pd/checksheet/delete",
                dataReq: {
                    "checksheetid": ""
                }
            }
        },
        action: [
            {
                name: "Edit",
                mode: "modal-form", /// page, modal, form
                option: {
                    type: "update"
                }
            }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Check Sheet Management.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default ProductionChecksheetSheet;